import { inject, injectable } from 'inversify';
import { getRealm } from 'samolet-oauth2';
import { RpcResult } from 'centrifuge';
import { Toast } from '@10d/tend-ui/primitives';
import { EGlobalDIKeys } from 'core/di/keys';
import type { IWebSocketService } from '../WebSocketService';
import { IRPCMessage, IRPCService } from './types';

@injectable()
class RPCService implements IRPCService {
  constructor(
    @inject(EGlobalDIKeys.WebSocketService)
    private readonly _wsService: IWebSocketService,
  ) {}

  send = async <Data, Meta>(
    message: IRPCMessage<Meta>,
    data?: Data,
    meta?: Meta,
  ): Promise<RpcResult> => {
    const client = this._wsService.getClient();
    if (!client) throw new Error('Cannot send RPC message without WS client');
    if (client.state !== 'connected')
      throw new Error('Cannot send RPC message without WS connection');

    try {
      return await client.rpc(
        `${message.channel.getNamespace()}.${message.messageType}`,
        {
          data: data || {},
          meta: {
            realm: getRealm(),
            token: this._wsService.getToken(),
            ...message.meta,
            ...meta,
          },
        },
      );
    } catch (error: any) {
      console.error(error);
      if (error?.message?.length) {
        Toast.error({
          message: error.message,
        });
      }
      throw error;
    }
  };
}

export default RPCService;
